import React from 'react';

const PrimaryButton = ({ buttonText, linkTo }) => (
  <div className="btn-part mt-20 md-mt-15 mb-20 md-mb-15">
    <a className="readon btn-text orange" href={linkTo}>
      <span>
        {buttonText}
      </span>
    </a>
  </div>
);

export default PrimaryButton;
